import React from 'react';

import { Input as ChakraInput, InputGroup, InputRightElement, forwardRef, InputLeftElement } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledInputGroup = styled(InputGroup)`
  & path {
    fill: ${(props) => props.theme.colors.text.g3};
  }

  &:focus-within {
    & path {
      fill: ${(props) => props.theme.colors.text.g1};
    }
  }
`;

const StyledInput = styled(ChakraInput)`
  border: ${(props) => (props.border ? props.border : `1px solid ${props.theme.colors.neutral.CCCCCC}`)};
  border-radius: 4px;
  ${(props) => (props.leftComponent ? 'padding-left: 38px;' : '')}
  ${(props) => (props.rightComponent ? 'padding-right: 38px;' : '')}

  font-weight: 400;
  font-size: 14px;
  line-height: 140%;

  &:hover {
    border: 1px solid ${(props) => props.theme.colors.text.g1};
  }
  &:focus {
    border: 1.2px solid ${(props) => props.theme.colors.functional['1565BC']} !important;
    box-shadow: 0px 0px 4px rgba(0, 142, 240, 0.2) !important;
  }
`;

const ChakraStyleInput = forwardRef(({ leftComponent, rightComponent, inputGroupProps = {}, ...props }, ref) => (
  <StyledInputGroup {...inputGroupProps}>
    {leftComponent && <InputLeftElement pointerEvents="none">{leftComponent}</InputLeftElement>}
    <StyledInput
      ref={ref}
      _placeholder={{ color: '#999999' }}
      leftComponent={!!leftComponent}
      rightComponent={!!rightComponent}
      {...props}
    />
    {rightComponent && <InputRightElement>{rightComponent}</InputRightElement>}
  </StyledInputGroup>
));

export { ChakraStyleInput };
